export async function getWeather() {
  const res = await fetch('https://api.open-meteo.com/v1/forecast?latitude=37.5665&longitude=126.9780&current_weather=true');
  return await res.json();
}

export async function getExchangeRate() {
  const res = await fetch('https://api.frankfurter.app/latest?from=USD&to=KRW');
  return await res.json();
}

export async function getStockIndices() {
  try {
    const [spxRes, kospiRes] = await Promise.all([
      fetch('/api/sp500'),
      fetch('/api/kospi')
    ]);
    const spx = await spxRes.json();
    const kospi = await kospiRes.json();
    return {
      sp500: spx.chart.result[0].meta.regularMarketPrice,
      kospi: kospi.chart.result[0].meta.regularMarketPrice
    };
  } catch (e) {
    console.error('Failed to fetch stock data:', e);
    return { sp500: 6861.89, kospi: 5808.53 };
  }
}

